import Badge from '@components/Badge';
import Column from '@components/Column';
import Divider from '@components/Divider';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useTestUser from '@hooks/test/useTestUser';
import useAppCustom from '@hooks/useAppCustom';
import useProject from '@hooks/useProject';

import img from './img.png';

function CheckingService() {
    const project = useProject();
    const isTestUser = useTestUser();
    const custom = useAppCustom();
    const isChecking = !isTestUser && (project?.status === 'PENDING' || project?.status === 'CLOSED');
    if (isChecking) {
        return (
            <Container>
                <Column align='center' spacing={5}>
                    <Logo src={custom?.main.logo} />
                    <Text size='display' fontWeight='bold'>
                        {project?.name} APP 점검 안내
                    </Text>
                </Column>
                <Divider isThin />
                <Column align='center' spacing={5}>
                    <Column spacing={3} align='center'>
                        <Badge>점검 시간</Badge>
                        <Text>
                            6월 8일(월) 22:00 ~ 6월 9일(화) 06:00
                        </Text>
                    </Column>
                    <Text as='div' color={colors.red} size='body-long'>
                        <Warning>
                            <li>해당 시간에는 앱 및 {project?.name} 오더 이용이 제한됩니다.</li>
                            <li>점검시간은 변동 될 수 있습니다.</li>
                        </Warning>
                    </Text>
                </Column>
                <Divider isThin />
                <Column align='center' spacing={4}>
                    <Text align='center' color={colors.textSecondary} size='body-short'>
                        안정적인 서비스 이용 환경 조성을 위한<br/>
                        점검에 양해 말씀드립니다.<br/>
                        <br/>
                        감사합니다.
                    </Text>
                    <Image src={img}
                        width={120}
                    />
                </Column>
            </Container>
        );
    }
    return null;
}

const Container = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: white;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: calc(64px + var(--safe-area-top)) 20px 0;
    gap: 28px;
`;

const Logo = styled(Image)`
    width: 220px;
`;

const Warning = styled.ul`
    list-style: disc;
`;

export default CheckingService;
